import { useState } from 'react';
import { useSafeLayoutEffect } from './useSafeLayoutEffect';
export const useOverflow = ref => {
  const [isOverflow, setIsOverflow] = useState(false);
  useSafeLayoutEffect(() => {
    const {
      current
    } = ref;
    const trigger = () => {
      const hasOverflow = current.scrollHeight > current.clientHeight;
      setIsOverflow(hasOverflow);
    };
    let observer;
    if (current) {
      observer = new ResizeObserver(trigger);
      observer.observe(current);
      trigger();
    }
    return () => {
      var _observer;
      return (_observer = observer) === null || _observer === void 0 ? void 0 : _observer.disconnect();
    };
  });
  return isOverflow;
};